import axios from 'axios'
import localStore from 'util/localStore'
import router from '../router'
import { Notification } from 'element-ui'

// 请求成功，返回的状态码不是业务定义状态码时调用
const statusError = (err) => {
  Notification.error({
    title: '错误',
    message: err.message
  })
}

// 网络出错时调用
const requestError = (err) => {
  // let errorText = ''
  // if (err.response && err.response.status) {
  //   errorText = '请求错误：' + err.response.status + ',' + err.response.statusText
  // }
  // if (/Error/.test(err)) {
  //   errorText = '请求超时'
  // }
  Notification.error({
    title: '错误',
    message: err.response.data.message || err.message
  })
}

axios.defaults.timeout = 30 * 1000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = process.env.FMS_SERVICE_IP

axios.interceptors.request.use((config) => {
  config.headers.common['x_user_id'] = localStore.get('TUP_pUid')
  config.headers.common['x_auth_token'] = localStore.get('TUP_token')
  config.headers.common['x_request_platform'] = 'WEB'
  config.headers.common['x_request_application'] = 'fms_web'
  config.headers.common['x_province_code'] = localStore.get('TUP_pCitprovincialoffice')
  config.headers.common['x_type'] = localStore.get('TUP_pFirstorderDate') === null ? 'true' : 'false' // 普订'false' 首订'true'

  return config
}, (err) => {
  return Promise.reject(err)
})

axios.interceptors.response.use((rs) => {
  let codeArr = ['1410', '1411', '1415', '1102', '1420', '1421', '1422'] // 做另外处理的resultCode
  if (rs.data.success) {
    return rs
  } else {
    if (rs.data.resultCode === '403') {
      localStore.clear()
      statusError(rs.data)
      router.push({
        path: '/login'
      })
      return
    } else if (codeArr.indexOf(rs.data.resultCode) >= 0) { // 特殊性：兼容提交订单接)
      return rs
    }
    statusError(rs.data)
    return Promise.reject(rs.data)
  }
}, (err) => {
  requestError(err)
})

export default function (options) {
  if (!options) {
    return
  }

  let config = {
    url: options.url,
    method: options.method
  }
  if (options.method === 'get') {
    config.params = options.data
  }
  if (options.method === 'post') {
    config.data = options.data
  }
  return new Promise((resolve, reject) => {
    axios(config).then(rs => {
      //console.log("rs.data",rs)
      if(rs){
        resolve(rs.data)
      }else{
        reject(rs)
      }
    }, err => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/axios.js